interface GetNodesFromHtml {
    /** The HTML string to parse */
    html: string;
    /** DOM selector, argument passed to `querySelectorAll` */
    selectors?: string;
}
const getNodesFromHtml = ({ html, selectors = '*' }: GetNodesFromHtml) => {
    const dom = new DOMParser().parseFromString(html, 'text/html');
    return dom.querySelectorAll<HTMLElement>(selectors);
};

export { getNodesFromHtml };
